import { render, staticRenderFns } from "./BaseBannerFixed.vue?vue&type=template&id=d54ec768"
import script from "./BaseBannerFixed.vue?vue&type=script&lang=js"
export * from "./BaseBannerFixed.vue?vue&type=script&lang=js"
import style0 from "./BaseBannerFixed.vue?vue&type=style&index=0&id=d54ec768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports